import { createFileRoute } from "@tanstack/react-router";

import GigsClaim from "@/features/gigs/GigsClaim";
import SideNavLayout from "@/layouts/SideNavLayout";
import { GigsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/gigs/claim/")({
  component: () => (
    <SideNavLayout menu={<GigsMenu />}>
      <GigsClaim key="create" />
    </SideNavLayout>
  ),
});
